export default "__VITE_ASSET__DlY5tJDB__";